

function ContactArea() {
  
    return (
        <h1>Contact Page</h1>
    )

}

export default ContactArea
